import type { IconSvgObject } from './types';

const FolderArchiveIcon: IconSvgObject = [
  ["path", { d: "M14 16.5V15M14 11.5V10.5M16 19C16 20.1046 15.1046 21 14 21C12.8954 21 12 20.1046 12 19C12 17.8954 12.8954 17 14 17C15.1046 17 16 17.8954 16 19Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V19C22 20.1046 21.1046 21 20 21H19M12.0179 6.99446L9.60016 3.79437C9.22218 3.29407 8.63144 3 8.0044 3H4C2.89543 3 2 3.89543 2 5V19C2 20.1046 2.89543 21 4 21H9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default FolderArchiveIcon;
